/**
 * Reload the document — the one statement of that seam (021).
 *
 * Two callers need it: `update.store.ts` after activating a new version, and `reconnect.ts` when
 * the connection returns. Both previously injected `DOCUMENT` for this single expression, and only
 * one carried the two reasons it is written this way — so the other was a line anybody could
 * "simplify" to `window.location.reload()` without knowing what that costs.
 *
 * Through the injected document, never the global, because a unit test must be able to supply a
 * document whose reload does not take the test runner with it.
 *
 * And it is a REQUEST, not a guarantee: `defaultView` can be null and a reload can be refused, so
 * a caller must not treat the call as the end of its own story. `update.store.ts` clears its
 * `applying` flag afterwards for exactly that reason.
 */
export function reloadPage(doc: Document): void {
  doc.defaultView?.location.reload();
}
